const sharedPalette = Object.freeze({
  ink: "#020506",
  panel: "#070b0d",
  white: "#f4f8fa",
  cyan: "#1ef5ef",
  red: "#ff2929",
  line: "#50616a",
});

const GHOSTLINE = Object.freeze({
  id: "ghostline",
  route: "/signup/",
  ordinal: "PUBLIC ACCESS NODE",
  name: "Ghostline Concourse",
  shortName: "Ghostline",
  eyebrow: "SOCIAL ACCESS // TRANSIT NODE 07",
  title: "Enter the living network.",
  description: "Review the future Exiled identity enrollment experience. Registration is installed but remains locked.",
  sceneLabel: "CONCOURSE LINK",
  telemetry: Object.freeze([
    "REGISTRATION LOCKED",
    "EMAIL VERIFICATION PENDING",
    "TERMS DRAFT AVAILABLE",
  ]),
  worldFilm: Object.freeze({
    poster: "/assets/world-films/ghostline-poster.webp",
    sources: Object.freeze([
      Object.freeze({ src: "/assets/world-films/ghostline.webm", type: "video/webm" }),
      Object.freeze({ src: "/assets/world-films/ghostline.mp4", type: "video/mp4" }),
    ]),
    objectPosition: "50% 46%",
    opacity: 0.72,
    foreground: null,
  }),
  cinematicVfx: Object.freeze({
    id: "storm-lance",
    label: "Storm Lance",
    src: "/assets/vfx-masters/storm-lance-packed-alpha.webm",
    sources: Object.freeze([
      Object.freeze({ src: "/assets/vfx-masters/storm-lance-packed-alpha.webm", type: "video/webm" }),
      Object.freeze({ src: "/assets/vfx-masters/storm-lance-packed-alpha.mp4", type: "video/mp4" }),
    ]),
    poster: "/assets/vfx-masters/storm-lance-transparent.webp",
    packing: "premultiplied-rgb-alpha-side-by-side",
    alphaFloor: 0.00784313725490196,
    transparent: true,
    duration: 6.7,
    playbackRate: 0.78,
    timeOffset: 0.7,
    position: Object.freeze({ x: "42.5vw", y: "62vh", width: "clamp(460px, 32vw, 540px)", rotation: "-0.6deg" }),
    mobilePosition: Object.freeze({ x: "64%", y: "clamp(320px, 40.5vh, 350px)", width: "min(86vw, 440px)" }),
    treatment: Object.freeze({ opacity: 0.24, brightness: 0.63, contrast: 1.18, saturation: 0.9, hue: "0deg", scaleX: 1, scaleY: 1 }),
  }),
  scene: Object.freeze({
    source: Object.freeze({ enabled: false }),
    primaryEnvironment: Object.freeze({ enabled: false }),
    secondaryMotion: Object.freeze({ enabled: false }),
    cinematicEvent: Object.freeze({ enabled: false }),
  }),
  palette: Object.freeze({ ...sharedPalette, accent: "#1ef5ef", secondary: "#58a7ff", danger: "#ff2929" }),
  motion: Object.freeze({ density: 1, parallax: 0.9, activity: 0.82, bloom: 0.72, pedestrians: 0, proceduralPeople: false }),
});

export const SIGNUP_CONCEPTS = Object.freeze([GHOSTLINE]);

export function conceptById() {
  return GHOSTLINE;
}

export function conceptFromPath() {
  return GHOSTLINE;
}

